<div class="tutor-filter-control">
  <nb-select
    size="medium"
    [selected]="selectedTutorId || allTutorsValue"
    (selectedChange)="onTutorSelect($event)"
    [placeholder]="'pages.analytics.filters.tutor' | translate"
  >
    <nb-option [value]="allTutorsValue">
      <span class="all-agents-option">
        {{ 'pages.analytics.filters.allTutors' | translate }}
      </span>
    </nb-option>
    <nb-option
      *ngFor="let tutor of tutorService.tutors$ | async"
      [value]="tutor.id"
    >
      <app-agent-identity-label
        [visualName]="tutor.visual_name"
        [internalName]="tutor.name"
        [fallback]="tutor.id"
      ></app-agent-identity-label>
    </nb-option>
  </nb-select>
</div>
